import React, { useState, useRef, useEffect } from "react";
import Select from "react-select";
import {
  Button,
  Card,
  CardBody,
  Label,
  FormGroup,
  Input,
  Row,
  Col,
  CustomInput,
} from "reactstrap";
import noperson from "../../assets/img/addlogo.png";
import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import axios from "axios";
import {
  INSERT_CLIENT,
  UPDATE_CLIENT,
  BASE_URL_CHAT_WHATSAPP,
  CLIENT_BY_ID,
  CLIENT_GATEWAY_LIST,
  ALL_CLIENT_LIST,
  ROLE_SUPER_ADMIN_NAME
} from "../../../src/constants";
import { useHistory } from "react-router-dom";
import NotificationAlert from "react-notification-alert";


let selectType = [
  { value: 1, label: "Prepaid" },
  { value: 2, label: "Postpaid" },
];
let email_gateway = [];
let sms_gateway = [];
let ivr_gateway = [];
let whatsapp_gateway = [];
let rcs_gateway = [];

let email_account = [];
let sms_account = [];
let ivr_account = [];
let whatsapp_account = [];
let rcs_account = [];

let rcsInitial = {
  rcsgatewy: 0,
  rcsacnt: 0,
  rcsbot: 0,
  rcsagent: 0,
  rcsactve: 0,
  rcsid: 0,
};

let emailInitial = {
  emailgatewy: 0,
  emailacnt: 0,
  emailbot: 0,
  emailagent: 0,
  emailactve: 0,
  emailid: 0
};
let smsInitial = {
  smsgatewy: 0,
  smsacnt: 0,
  smsbot: 0,
  smsagent: 0,
  smsactve: 0,
  smsid: 0
};
let ivrInitial = {
  ivrgatewy: 0,
  ivracnt: 0,
  ivrbot: 0,
  ivragent: 0,
  ivractve: 0,
  ivrid: 0
};
let whatsappInitial = {
  whatsappgatewy: 0,
  whatsappacnt: 0,
  whatsappbot: 0,
  whatsappagent: 0,
  whatsappactve: 0,
  whatsappid: 0
};
let initialValues = {
  name: "",
  mobile: "",
  email: "",
  address: "",
  cname: "",
  cMobile: "",
  profile: noperson,
  noofusers: 0,
  isActive: false,
  peid: "",
  systemId: "",
  namespace: "",
  appid: "",
  accesstoken: "",
  phoneid: "",
  wabaid:"",
  whatsappclientid: "",



  emailTemp: emailInitial,
  rcsTemp: rcsInitial,
  whatsappTemp: whatsappInitial,
  ivrTemp: ivrInitial,
  smsTemp: smsInitial,
  account_type: { value: 2, label: "Postpaid" },
  count: 0,
  isreseller:0
};

const CreateClient = (props) => {
  const [client, setClient] = useState(initialValues);
  const [errorhandle, setErrorHandle] = useState()
  const [clientList, setClientList] = useState([])
  const inputFile = useRef(null);
  const notificationAlertRef = useRef(null);
  const navigate = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  let userObj = localStorage.getItem("user");
  let user = JSON.parse(userObj);
  const [channelData, setChannelData] = useState([])

  useEffect(() => {
  
    getProviders();
  
    getClientList();
    fetchClient();
  }, []);
  const getClientList = async () => {
    setIsLoading(true);
    await axios
      .get(`${ALL_CLIENT_LIST}?client_id=${user?.client}`)
      .then((res) => {
        setClientList(res?.data?.data)
        setIsLoading(false);
        user?.isreseller==1&&setClient({...client,account_type:{ value: 1, label: "Prepaid" }})
      })
      .catch((err) => {  
        setIsLoading(false);
        console.log(err);
      })
  };

  const getProviders = () => {
    setIsLoading(true);
    axios.get(CLIENT_GATEWAY_LIST).then(res => {
      setIsLoading(false)
      setChannelData(res?.data)
      res?.data?.map((item, index) => {


        if (item?.channel?.toLowerCase() === "sms") {
          sms_gateway.push({ value: item.vendor_name, label: item.vendor_name })



        } else if (item?.channel?.toLowerCase() === "whatsapp") {
          whatsapp_gateway.push({ value: item.vendor_name, label: item.vendor_name })
        } else if (item?.channel?.toLowerCase() === "ivr") {
          ivr_gateway?.push({ value: item.vendor_name, label: item.vendor_name })
        } else if (item?.channel?.toLowerCase() === "email") {
          email_gateway.push({ value: item.vendor_name, label: item.vendor_name })
        } else if (item?.channel?.toLowerCase() === "rcs") {
          rcs_gateway.push({ value: item.vendor_name, label: item.vendor_name })
        }
      })


    }).catch(e => {
      let options = {};
      options = {
        place: "tr",
        message: e.code,
        type: "warning",
        autoDismiss: 2,
      };
      setIsLoading(false);
      notificationAlertRef.current.notificationAlert(options);
    })
  }
  const fetchClient =  () => {
    if (props?.location?.state?.id) {
      let id = props?.location?.state?.id;

       axios
        .post(CLIENT_BY_ID, { id: id })
        .then((res) => {
          let clientObj = res?.data[0];

          setClient({
            ...client,
            name: clientObj.company_name,
            mobile: clientObj?.company_mobile,
            email: clientObj?.company_email,
            address: clientObj?.company_address,
            cname: clientObj?.contact_person,
            cMobile: clientObj?.contact_mobile,
            profile: clientObj?.image_url,
            noofusers: clientObj?.number_of_users,
            peid: clientObj?.peid,
            systemId: clientObj?.system_id,
            account_type: clientObj?.client_acc_type == 1 ? { value: 1, label: "Prepaid" } : { value: 2, label: "Postpaid" },
            count: clientObj?.client_count,
            isreseller: clientObj?.is_reseller,
            accesstoken: clientObj?.access_token,
            namespace: clientObj?.namespace,
            appid: clientObj?.whatsapp_appid,
            whatsappclientid:clientObj?.whatsappclientid,
            phoneid:clientObj?.phoneid,
            wabaid:clientObj?.wabaid,

            isActive: clientObj?.status == 0 ? false : true
            //   : setClient({...client,isActive:true});
          });
          res?.data?.map((item, index) => {

            if (item?.channels_type == "email") {
              const emailObj = JSON.parse(item?.templates);
              setClient(preClient => ({
                ...preClient, emailTemp: {
                  ...preClient.emailTemp,
                  emailgatewy: emailObj?.emailgatewy,
                  emailacnt: emailObj?.emailacnt,
                  emailbot: emailObj?.emailbot,
                  emailagent: emailObj?.emailagent,
                  emailactve: emailObj?.emailactve,
                  emailid: item.id
                }

              }))
            }
            else if (item?.channels_type == "sms") {
              const smsObj = JSON.parse(item?.templates);
              setClient(preClient => ({
                ...preClient, smsTemp: {
                  ...preClient.smsTemp,
                  smsgatewy: smsObj?.smsgatewy,
                  smsacnt: smsObj?.smsacnt,
                  smsbot: smsObj?.smsbot,
                  smsagent: smsObj?.smsagent,
                  smsactve: smsObj?.smsactve,
                  smsid: item.id
                }
              }))
            } else if (item?.channels_type == "whatsapp") {
              const whatsappObj = JSON.parse(item?.templates);
              setClient(preClient => ({
                ...preClient, whatsappTemp: {
                  ...preClient.whatsappTemp,
                  whatsappgatewy: whatsappObj?.whatsappgatewy,
                  whatsappacnt: whatsappObj?.whatsappacnt,
                  whatsappbot: whatsappObj?.whatsappbot,
                  whatsappagent: whatsappObj?.whatsappagent,
                  whatsappactve: whatsappObj?.whatsappactve,
                  whatsappid: item.id
                }
              }))
            } else if (item?.channels_type == "ivr") {
              const ivrObj = JSON.parse(item?.templates);
              setClient(preClient => ({
                ...preClient, ivrTemp: {
                  ...preClient.ivrTemp,
                  ivrgatewy: ivrObj?.ivrgatewy,
                  ivracnt: ivrObj?.ivracnt,
                  ivrbot: ivrObj?.ivrbot,
                  ivragent: ivrObj?.ivragent,
                  ivractve: ivrObj?.ivractve,
                  ivrid: item.id
                }
              }))
            } else if (item?.channels_type == "rcs") {
              const rcsObj = JSON.parse(item?.templates);
              setClient(preClient => ({
                ...preClient, rcsTemp: {
                  ...preClient.rcsTemp,
                  rcsgatewy: rcsObj?.rcsgatewy,
                  rcsacnt: rcsObj?.rcsacnt,
                  rcsagent: rcsObj?.rcsagent,
                  rcsbot: rcsObj?.rcsbot,
                  rcsactve: rcsObj?.rcsactve,
                  rcsid: item.id
                }
              }))
            }
          })


        })
        .catch((e) => {
          console.log(e);
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef.current.notificationAlert(options);
        });
    }
  };


  const uploadProfile = (e) => {
    setIsLoading(true)
    const formData = new FormData();
    formData.append("file", e?.target?.files[0]);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(BASE_URL_CHAT_WHATSAPP + "/upload", formData, config)
      .then((response) => {
        setClient({ ...client, profile: response?.data?.Response });
        setIsLoading(false)
      })
      .catch((err) => {
        console.log("err==>", err);
        let options = {};
        options = {
          place: "tr",
          message: "Unable to upload",
          type: "warning",
          autoDismiss: 2,
        };
        setIsLoading(false);
        notificationAlertRef.current.notificationAlert(options);
      });
  };

  const isValidForm = () => {

    //  const onlyltrs = /^[a-zA-Z ]+$/;
    const onlyltrs = /^([^0-9]*)$/;
    const errors = {};
    if (!client.name.trim()) {
      errors.clientname = "Company Name Required"
    } else if (!(client?.name.match(onlyltrs))) {
      errors.clientname = "Name Should be alphabets"
    }
    if (client.name && !(props?.location?.state?.id)) {
      const exist = clientList.filter(item => item.company_name.toLowerCase() === client.name.toLowerCase());
      if (exist.length > 0) {
        errors.clientname = "Already Exist"
      }


    }
    if (client.mobile == "") {
      errors.clientmobile = "Mobile Number Required"
    } else if (client.mobile.length != 10) {
      errors.clientmobile = "Number Should be 10 digits"
    }
    if (client.account_type == "") {
      errors.account_type = "Account Type Required"
    }
    // if (client.mobile && !(props?.location?.state?.id)) {
    //   const exist = clientList.filter(item => item.company_mobile.toLowerCase() === client.mobile.toLowerCase())
    //   if (exist.length > 0) {
    //     errors.clientmobile = "Already Exist"
    //   }
    // }
    const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    if (client.email == "") {
      errors.email = "Email Required"
    } else if (!(client.email.match(isValidEmail))) {
      errors.email = "Please enter valid Email "
    }
    if (client.email && !(props?.location?.state?.id)) {
      const exist = clientList.filter(item => item.company_email.toLowerCase() === client.email.toLowerCase())
      if (exist.length > 0) {
        errors.email = "Already Exist"
      }
    }

    if (!client.cname.trim()) {
      errors.cname = "Contact Person Required"
    } else if (!(client?.cname.match(onlyltrs))) {
      errors.cname = "Name Should be alphabets"
    }
    if (client.cMobile == "") {
      errors.cMobile = "Mobile Number Required"
    } else if (client.cMobile.length != 10) {
      errors.cMobile = "Number Should be 10 digits"
    }
    if (client.cMobile && !(props?.location?.state?.id)) {
      const exist = clientList.filter(item => item.contact_mobile.toLowerCase() === client.cMobile.toLowerCase())
      if (exist.length > 0) {
        errors.cMobile = "Already Exist"
      }
    }
    if (!client.address.trim()) {
      errors.address = "Address Required"
    } else if (client.address.length < 5) {
      errors.address = "Please provide corrrect address"
    }
    return errors;
  }

  const addClient = (e) => {
    var userObj = localStorage.getItem("user");
    var user = JSON.parse(userObj);
    e.preventDefault();

    const isValid = isValidForm();
    setErrorHandle(isValid)
    if (Object.keys(isValid).length == 0) {
      let payload = {
        companyname: client?.name,
        companymobile: client?.mobile,
        companyemail: client?.email,
        contactaddress: client?.address,
        contactperson: client?.cname,
        contactmobile: client?.cMobile,
        imageurl: client?.profile,
        isactive: client?.isActive ? 1 : 0,
        numberofusers: client?.noofusers,
        smsTemp: client?.smsTemp,
        emailTemp: client?.emailTemp,
        ivrTemp: client?.ivrTemp,
        whatsappTemp: client?.whatsappTemp,
        rcsTemp: client?.rcsTemp,
        peid: client?.peid,
        systemId: client?.systemId,
        appid: client?.appid,
        accesstoken: client?.accesstoken,
        namespace: client?.namespace,

        account_type: client?.account_type?.value,
        count: client?.count,
        isreseller: client?.isreseller,
        reseller_id: user?.isreseller==1?user?.client:0,
        phoneid:client?.phoneid,
        wabaid:client?.wabaid,

        whatsappclientid:client?.whatsappclientid
      };
      if (props?.location?.state?.id) {
        const reqbody = { ...payload, id: props?.location?.state?.id };
        axios
          .post(UPDATE_CLIENT, reqbody)
          .then((data) => {
            if (data.status == 200) {
              let options = {};
              options = {
                place: "tr",
                message: "Updated Successfully",
                type: "success",
                autoDismiss: 2,
              };
              notificationAlertRef.current.notificationAlert(options);
              setTimeout(() => {
                navigate.push("/admin/clients");
              }, 1000)

            }
          })
          .catch((err) => {
            console.log(err)
            let options = {};
            options = {
              place: "tr",
              message: err.code,
              type: "warning",
              autoDismiss: 2,
            };
            notificationAlertRef.current.notificationAlert(options);
          });
      } else {


        axios
          .post(INSERT_CLIENT, payload)
          .then((data) => {
            if (data.status == 200) {


              let options = {};
              options = {
                place: "tr",
                message: "Saved Successfully",
                type: "success",
                autoDismiss: 2,
              };
              notificationAlertRef.current.notificationAlert(options);
              setTimeout(() => {
                navigate.goBack();
              }, 1000)

            }
          })
          .catch((err) => console.log(err));
      }
    }

  };

  const addacount = (channel, value) => {

    channelData?.map(item => {

      if (channel?.toLowerCase() === "sms" && "sms" === item?.channel?.toLowerCase() && value?.value?.toLowerCase() === item?.vendor_name?.toLowerCase()) {

        sms_account.push({ value: item.account_id, label: item.account_id })
      } else if (channel?.toLowerCase() === "whatsapp" && "whatsapp" === item?.channel?.toLowerCase() && value?.value?.toLowerCase() === item?.vendor_name?.toLowerCase()) {
        whatsapp_account.push({ value: item.account_id, label: item.account_id })

      } else if (channel?.toLowerCase() === "ivr" && "ivr" === item?.channel?.toLowerCase() && value?.value?.toLowerCase() === item?.vendor_name?.toLowerCase()) {
        ivr_account?.push({ value: item.account_id, label: item.account_id })
      }

      else if (channel?.toLowerCase() === "email" && "email" === item?.channel?.toLowerCase() && value?.value?.toLowerCase() === item?.vendor_name?.toLowerCase()) {

        email_account.push({ value: item.account_id, label: item.account_id })
      } else if (channel?.toLowerCase() === "rcs" && "rcs" === item?.channel?.toLowerCase() && value?.value?.toLowerCase() === item?.vendor_name?.toLowerCase()) {
        rcs_account.push({ value: item.account_id, label: item.account_id })
      }
    })

  }
  return (
    <>
      <LoadingScreen
        children=""
        loading={isLoading}
        bgColor="rgba(0,0,0,0.7)"
        spinnerColor="#9ee5f8"
        textColor="#676767"
        logoSrc={logo}
        text="Loading..."
      ></LoadingScreen>
      <div className="content pd-0">
        <Row>
          <Card>
            <CardBody className="mb-0">
              <NotificationAlert ref={notificationAlertRef} />

              <Row>
                <Col sm="10">
                  <h4 className="mt-4 add-content" style={{ "width": "200px" }}
                    onClick={() => navigate.push("/admin/clients")}>
                    <Button
                      className="btn btn-icon btn-link-add btn-sm mr-2"
                    >
                      {/* <i class="tim-icons icon-minimal-left"
                       */}
                      <i class="fa fa-arrow-left" aria-hidden="true"></i>
                    </Button>

                    {props?.location?.state?.id ? "Update Client" : "Create Client"}
                  </h4>
                </Col>
              </Row>
                       {console.log("ui calling ",client)}
              <Row>
                <Row>
                  <Col md="10" sm="8">
                    <Row>
                      <Col sm="3" className="mb-2">
                        <label>Company <suf style={{ color: "red" }}>*</suf> </label>
                        <FormGroup>
                          <Input
                            label="Name"
                            type="text"
                            name="name"
                            value={client.name}
                            onChange={(e) => {
                              setClient({ ...client, name: e?.target?.value })
                            }

                            }
                          />
                        </FormGroup>

                        <span style={{ color: "red" }}>{errorhandle?.clientname}</span>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <label>Mobile<suf style={{ color: "red" }}>*</suf></label>

                        <FormGroup>
                          <Input
                            label="Phone No"
                            type="number"
                            maxLength={10}
                            value={client.mobile}
                            onChange={(e) => {
                              setClient({ ...client, mobile: e?.target?.value })
                            }
                            }
                          />
                        </FormGroup>
                        <span style={{ color: "red" }}>{errorhandle?.clientmobile}</span>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <label>Email <suf style={{ color: "red" }}>*</suf></label>
                        <FormGroup>
                          <Input
                            label="Email "
                            type="email"
                            value={client.email}
                            onChange={(e) => {
                              setClient({ ...client, email: e?.target?.value })
                            }
                            }
                          />
                        </FormGroup>

                        <span style={{ color: "red" }}>{errorhandle?.email}</span>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <label>Contact Person <suf style={{ color: "red" }}>*</suf></label>

                        <FormGroup>
                          <Input
                            label="Contact Person"
                            type="text"
                            value={client.cname}
                            onChange={(e) => {
                              setClient({ ...client, cname: e?.target?.value })
                            }

                            }
                          />
                        </FormGroup>
                        <span style={{ color: "red" }}>{errorhandle?.cname}</span>
                      </Col>
                    </Row>

                    <Row>
                     
                      <Col sm="3" className="mb-2">
                        <label>Contact Phone No <suf style={{ color: "red" }}>*</suf></label>

                        <FormGroup>
                          <Input
                            label="Contact Phone No"
                            maxLength={10}
                            type="number"
                            value={client.cMobile}
                            onChange={(e) => {
                              setClient({ ...client, cMobile: e?.target?.value })
                            }

                            }
                          />
                        </FormGroup>
                        <span style={{ color: "red" }}>{errorhandle?.cMobile}</span>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <label>Address <suf style={{ color: "red" }}>*</suf></label>

                        <FormGroup>
                          <Input
                           style={{ padding: "3px", resize:"auto",maxHeight:"none" }}
                            label="Address "
                            type="textarea"
                            maxLength={160}
                            value={client.address}
                            onChange={(e) =>
                              setClient({ ...client, address: e?.target?.value })
                            }
                          />
                        </FormGroup>
                        <span style={{ color: "red" }}>{errorhandle?.address}</span>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <label>PEID </label>
                        <FormGroup>
                          <Input
                            type="text"
                            name="peid"
                            value={client?.peid}
                            onChange={(e) =>
                              setClient({ ...client, peid: e?.target?.value })
                            }
                            placeholder="PE ID"
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <label>SystemId </label>
                        <FormGroup>
                          <Input
                            type="text"
                            name="systemId"
                            value={client.systemId}
                            onChange={(e) =>
                              setClient({ ...client, systemId: e?.target?.value })
                            }
                            placeholder="System id, Sytem id"
                          />
                        </FormGroup>
                      </Col>

                      {/* <Col sm="2" className="mb-2">
                        <label>No.of Users </label>

                        <FormGroup>
                          <Input
                            type="text"
                            maxLength={160}
                            value={client.noofusers}
                            onChange={(e) =>
                              setClient({ ...client, noofusers: e?.target?.value })
                            }
                          />
                        </FormGroup>
                      </Col> */}
                      <Col sm="3" className="mb-2">
                      <label>Users Type</label>
                      {user?.isreseller == 1 ?<FormGroup>
                          <Input
                            type="text"
                            readOnly={true}
                            value={client?.account_type?.label}
                            
                            
                          />
                        </FormGroup>:
                       <> <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                         
                          name="Select Channel"
                          value={client?.account_type}
                          onChange={(value) => {
                            setClient({ ...client, account_type: value });
                          }}
                          
                          options={selectType}
                          placeholder="Select User Type"
                        />
                        <span style={{ color: "red" }}>{errorhandle?.account_type}</span>
                        </>
                        }
                      </Col>
                      {/* {
                        client?.account_type?.value === 1 &&

                        <Col sm="3" className="mb-2 ">
                          <FormGroup>
                            <Input
                              placeholder="Enter Count"
                              type="text"
                              value={client.count}
                              onChange={(e) =>
                                setClient({ ...client, count: e?.target?.value })
                              }
                            />
                          </FormGroup>

                        </Col>
                      } */}
                     
                       <Col sm="3" className="mb-2">
                        <label>Token </label>
                        <FormGroup>
                          <Input
                            type="text"
                            name="accesstoken"
                            value={client?.accesstoken}
                            onChange={(e) =>
                              setClient({ ...client, accesstoken: e?.target?.value })
                            }
                            placeholder="Enter Access Token"
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <label>Name Space </label>
                        <FormGroup>
                          <Input
                            type="text"
                            name="namespace"
                            value={client?.namespace}
                            onChange={(e) =>
                              setClient({ ...client, namespace: e?.target?.value })
                            }
                            placeholder="Enter Name Space"
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <label>App Id </label>
                        <FormGroup>
                          <Input
                            type="text"
                            name="appid"
                            value={client?.appid}
                            onChange={(e) =>
                              setClient({ ...client, appid: e?.target?.value })
                            }
                            placeholder="Enter App ID"
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <label>Client Id </label>
                        <FormGroup>
                          <Input
                            type="text"
                            name="whatsappclientid"
                            value={client?.whatsappclientid}
                            onChange={(e) =>
                              setClient({ ...client, whatsappclientid: e?.target?.value })
                            }
                            placeholder="Enter Client ID"
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <label>Phone Id </label>
                        <FormGroup>
                          <Input
                            type="text"
                            name="phoneid"
                            value={client?.phoneid}
                            onChange={(e) =>
                              setClient({ ...client, phoneid: e?.target?.value })
                            }
                            placeholder="Enter Phone ID"
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <label>Waba Id </label>
                        <FormGroup>
                          <Input
                            type="text"
                            name="wabaid"
                            value={client?.wabaid}
                            onChange={(e) =>
                              setClient({ ...client, wabaid: e?.target?.value })
                            }
                            placeholder="Enter waba ID"
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="3" className="mb-2 ">
                        <div className="d-flex align-items-center">
                          <span className="mr-2">In-active</span>
                          <CustomInput
                            type="switch"
                            id="switch-5"
                            className="mt-n4"
                            checked={!client.isActive}
                            onChange={() =>
                              setClient({ ...client, isActive: !client.isActive })
                            }
                          />
                          <span className="ml-n2">Active</span>
                        </div>
                      </Col>
                      {
                        user?.role == ROLE_SUPER_ADMIN_NAME&&
                      
                      <Col sm="3" >
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={client.isreseller == 1 ? true : false}
                              value={client.isreseller}
                              onClick={(e) => { 
                                e?.target?.checked === true?setClient({...client,isreseller:1}):setClient({...client,isreseller:0})
                              }}
                            />
                            <span className="form-check-sign" /> Is Reseller
                          </Label>
                        </FormGroup>
                      </Col>
                      
                      }
                    </Row>

                  </Col>

                  <Col md="2" sm="4">
                    <Row style={{ backgroundColor: "#f3f3f3" }}>
                      <input
                        type="file"
                        accept=".jpg,.jpeg,.png,.svg"
                        ref={inputFile}
                        onChange={(e) => {
                          uploadProfile(e);
                        }}
                        style={{ display: "none" }}
                      />
                      <img
                        src={client.profile}
                        alt="no image"
                        onClick={() => inputFile.current.click()}
                        style={{
                          margin: "5px",
                          height: "200px",
                          width: "200px",
                          objectFit: "fill",
                        }}
                      />
                    </Row>{" "}
                    <Row>
                      <h5
                        style={{
                          backgroundColor: "#f3f3f3",
                          padding: "2px",
                          textAlign: "center",
                        }}
                      >
                        Upload image(200*200)
                      </h5>
                    </Row>
                  </Col>
                </Row>
                <Row style={{marginTop:15}}>
                  <Col xs="12">
                    <Row style={{ backgroundColor: "#a1919112", borderRadius: "5px", margin: "5px", padding: "5px", marginBottom: "15px" }}>
                      <Col sm="2" className="mb-2 ">
                        Channels
                      </Col>
                      <Col sm="3" className="mb-2 ">
                        Gateway
                      </Col>
                      <Col sm="2" className="mb-2 ">
                        Account
                      </Col>
                      <Col sm="2" className="mb-2 ">
                        Live Agent
                      </Col> <Col sm="1" className="mb-2 ">
                        bot
                      </Col> <Col sm="2" className="mb-2 ">
                        Is Active
                      </Col>
                    </Row>
                    <Row >
                      <Col sm="2" className="mb-2 ">
                        SMS
                      </Col>

                      <Col sm="3" className="mb-2">

                        <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="Select Channel"
                          value={client.smsTemp.smsgatewy}
                          onChange={(value) => {
                            sms_account = [];
                            addacount("sms", value)
                            setClient(prev => ({ ...prev, smsTemp: { ...prev.smsTemp, smsgatewy: value, smsacnt: 0 } }));
                          }}
                          options={sms_gateway.filter((item, i, s) => i == s.findIndex(t => t.label == item.label))}
                        />
                      </Col>
                      <Col sm="2" className="mb-2">
                        <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="Select Channel"
                          value={client.smsTemp.smsacnt}
                          onChange={(value) => {
                            setClient(prev => ({ ...prev, smsTemp: { ...prev.smsTemp, smsacnt: value } }));
                          }}
                          options={sms_account}
                        />
                      </Col>
                      <Col sm="2" className="mb-2 ">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={client.smsTemp.smsagent == 1 ? true : false}
                              value={client.smsTemp.smsagent}
                              onClick={(e) => {
                                e?.target?.checked === true
                                  ? setClient(prev => ({ ...prev, smsTemp: { ...prev.smsTemp, smsagent: 1 } }))
                                  : setClient(prev => ({ ...prev, smsTemp: { ...prev.smsTemp, smsagent: 0 } }));
                              }}
                            />
                            <span className="form-check-sign" />
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col sm="1" className="mb-2 ">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={client.smsTemp.smsbot == 1 ? true : false}
                              value={client.smsTemp.smsbot}
                              onClick={(e) => {
                                e?.target?.checked === true
                                  ? setClient(prev => ({ ...prev, smsTemp: { ...prev.smsTemp, smsbot: 1 } }))
                                  : setClient(prev => ({ ...prev, smsTemp: { ...prev.smsTemp, smsbot: 0 } }))
                              }}
                            />
                            <span className="form-check-sign" />
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col sm="2" className="mb-2 ">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={client.smsTemp.smsactve == 1 ? true : false}
                              value={client.smsTemp.smsactve}
                              onClick={(e) => {
                                e?.target?.checked === true
                                  ? setClient(prev => ({ ...prev, smsTemp: { ...prev.smsTemp, smsactve: 1 } }))
                                  : setClient(prev => ({ ...prev, smsTemp: { ...prev.smsTemp, smsactve: 0 } }))
                              }}
                            />
                            <span className="form-check-sign" />
                          </Label>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col sm="2" className="mb-2 ">
                        Email
                      </Col>
                      <Col sm="3" className="mb-2">

                        <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="Select Channel"
                          value={client.emailTemp.emailgatewy}
                          onChange={(value) => {
                            email_account = []
                            addacount("email", value)
                            setClient(prev => ({ ...prev, emailTemp: { ...prev.emailTemp, emailgatewy: value, emailacnt: 0 } }));
                          }}
                          options={email_gateway?.filter((item, i, s) => i === s.findIndex(t => t.label == item.label))}
                        />
                      </Col>
                      <Col sm="2" className="mb-2">
                        <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="Channel"
                          value={client.emailTemp.emailacnt}
                          onChange={(value) => {
                            setClient(prev => ({ ...prev, emailTemp: { ...prev.emailTemp, emailacnt: value } }));
                          }}
                          options={email_account}
                        />
                      </Col>
                      <Col sm="2" className="mb-2 ">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={client.emailTemp.emailagent == 1 ? true : false}
                              value={client.emailTemp.emailagent}
                              onClick={(e) => {
                                e?.target?.checked === true
                                  ? setClient(prev => ({ ...prev, emailTemp: { ...prev.emailTemp, emailagent: 1 } }))
                                  : setClient(prev => ({ ...prev, emailTemp: { ...prev.emailTemp, emailagent: 0 } }))
                              }}
                            />
                            <span className="form-check-sign" />
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col sm="1" className="mb-2 ">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={client.emailTemp.emailbot == 1 ? true : false}
                              value={client.emailTemp.emailbot}
                              onClick={(e) => {
                                e?.target?.checked === true
                                  ? setClient(prev => ({ ...prev, emailTemp: { ...prev.emailTemp, emailbot: 1 } }))
                                  : setClient(prev => ({ ...prev, emailTemp: { ...prev.emailTemp, emailbot: 0 } }))
                              }}
                            />
                            <span className="form-check-sign" />
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col sm="2" className="mb-2 ">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={client.emailTemp.emailactve == 1 ? true : false}
                              value={client.emailTemp.emailactve}
                              onClick={(e) => {
                                e?.target?.checked === true
                                  ? setClient(prev => ({ ...prev, emailTemp: { ...prev.emailTemp, emailactve: 1 } }))
                                  : setClient(prev => ({ ...prev, emailTemp: { ...prev.emailTemp, emailactve: 0 } }))
                              }}
                            />
                            <span className="form-check-sign" />
                          </Label>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2" className="mb-2 ">
                        Whatsapp
                      </Col>
                      <Col sm="3" className="mb-2">

                        <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="Select Channel"
                          value={client.whatsappTemp.whatsappgatewy}
                          onChange={(value) => {
                            whatsapp_account = []
                            addacount("whatsapp", value)
                            setClient(prev => ({ ...prev, whatsappTemp: { ...prev.whatsappTemp, whatsappgatewy: value, whatsappacnt: 0 } }));
                          }}
                          options={whatsapp_gateway?.filter((item, i, s) => i === s.findIndex(t => t.label == item.label))}
                        />
                      </Col>
                      <Col sm="2" className="mb-2">
                        <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="Select Channel"
                          value={client.whatsappTemp.whatsappacnt}
                          onChange={(value) => {
                            setClient(prev => ({ ...prev, whatsappTemp: { ...prev.whatsappTemp, whatsappacnt: value } }));
                          }}
                          options={whatsapp_account}
                        />
                      </Col>
                      <Col sm="2" className="mb-2 ">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={client.whatsappTemp.whatsappagent == 1 ? true : false}
                              value={client.whatsappTemp.whatsappagent}
                              onClick={(e) => {
                                e?.target?.checked === true
                                  ? setClient(prev => ({ ...prev, whatsappTemp: { ...prev.whatsappTemp, whatsappagent: 1 } }))
                                  : setClient(prev => ({ ...prev, whatsappTemp: { ...prev.whatsappTemp, whatsappagent: 0 } }))
                              }}
                            />
                            <span className="form-check-sign" />
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col sm="1" className="mb-2 ">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={client.whatsappTemp.whatsappbot == 1 ? true : false}
                              value={client.whatsappTemp.whatsappbot}
                              onClick={(e) => {
                                e?.target?.checked === true
                                  ? setClient(prev => ({ ...prev, whatsappTemp: { ...prev.whatsappTemp, whatsappbot: 1 } }))
                                  : setClient(prev => ({ ...prev, whatsappTemp: { ...prev.whatsappTemp, whatsappbot: 0 } }))
                              }}
                            />
                            <span className="form-check-sign" />{" "}
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col sm="2" className="mb-2 ">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={client.whatsappTemp.whatsappactve == 1 ? true : false}
                              value={client.whatsappTemp.whatsappactve}
                              onClick={(e) => {
                                e?.target?.checked === true
                                  ? setClient(prev => ({ ...prev, whatsappTemp: { ...prev.whatsappTemp, whatsappactve: 1 } }))
                                  : setClient(prev => ({ ...prev, whatsappTemp: { ...prev.whatsappTemp, whatsappactve: 0 } }))
                              }}
                            />
                            <span className="form-check-sign" />
                          </Label>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2" className="mb-2 ">
                        IVR
                      </Col>
                      <Col sm="3" className="mb-2">

                        <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="Select Channel"
                          value={client.ivrTemp.ivrgatewy}
                          onChange={(value) => {
                            ivr_account = []
                            addacount("ivr", value)
                            setClient(prev => ({ ...prev, ivrTemp: { ...prev.ivrTemp, ivrgatewy: value, ivracnt: 0 } }));
                          }}
                          options={ivr_gateway?.filter((item, i, s) => i === s.findIndex(t => t.label == item.label))}
                        />
                      </Col>
                      <Col sm="2" className="mb-2">
                        <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="Select Channel"
                          value={client.ivrTemp.ivracnt}
                          onChange={(value) => {
                            setClient(prev => ({ ...prev, ivrTemp: { ...prev.ivrTemp, ivracnt: value } }));
                          }}
                          options={ivr_account}
                        />
                      </Col>
                      <Col sm="2" className="mb-2 ">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={client.ivrTemp.ivragent == 1 ? true : false}
                              value={client.ivrTemp.ivragent}
                              onClick={(e) => {
                                e?.target?.checked === true
                                  ? setClient(prev => ({ ...prev, ivrTemp: { ...prev.ivrTemp, ivragent: 1 } }))
                                  : setClient(prev => ({ ...prev, ivrTemp: { ...prev.ivrTemp, ivragent: 0 } }))
                              }}
                            />
                            <span className="form-check-sign" />
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col sm="1" className="mb-2 ">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={client.ivrTemp.ivrbot == 1 ? true : false}
                              value={client.ivrTemp.ivrbot}
                              onClick={(e) => {
                                e?.target?.checked === true
                                  ? setClient(prev => ({ ...prev, ivrTemp: { ...prev.ivrTemp, ivrbot: 1 } }))
                                  : setClient(prev => ({ ...prev, ivrTemp: { ...prev.ivrTemp, ivrbot: 0 } }))
                              }}
                            />
                            <span className="form-check-sign" />
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col sm="2" className="mb-2 ">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={client.ivrTemp.ivractve == 1 ? true : false}
                              value={client.ivrTemp.ivractve}
                              onClick={(e) => {
                                e?.target?.checked === true
                                  ? setClient(prev => ({ ...prev, ivrTemp: { ...prev.ivrTemp, ivractve: 1 } }))
                                  : setClient(prev => ({ ...prev, ivrTemp: { ...prev.ivrTemp, ivractve: 0 } }))
                              }}
                            />
                            <span className="form-check-sign" />
                          </Label>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2" className="mb-2 ">
                        RCS
                      </Col>
                      <Col sm="3" className="mb-2">

                        <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="Select Channel"
                          value={client.rcsTemp.rcsgatewy}
                          onChange={(value) => {
                            rcs_account = []

                            addacount("rcs", value)
                            setClient(prev => ({ ...prev, rcsTemp: { ...prev.rcsTemp, rcsgatewy: value, rcsacnt: 0 } }));
                          }}
                          options={rcs_gateway?.filter((item, i, s) => i === s.findIndex(t => t.label == item.label))}
                        />
                      </Col>
                      <Col sm="2" className="mb-2">
                        <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="Select Channel"
                          value={client.rcsTemp.rcsacnt}
                          onChange={(value) => {
                            setClient(prev => ({ ...prev, rcsTemp: { ...prev.rcsTemp, rcsacnt: value } }));
                          }}
                          options={rcs_account}
                        />
                      </Col>
                      <Col sm="2" className="mb-2 ">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={client.rcsTemp.rcsagent == 1 ? true : false}
                              value={client.rcsTemp.rcsagent}
                              onClick={(e) => {
                                e?.target?.checked === true
                                  ? setClient(prev => ({ ...prev, rcsTemp: { ...prev.rcsTemp, rcsagent: 1 } }))
                                  : setClient(prev => ({ ...prev, rcsTemp: { ...prev.rcsTemp, rcsagent: 0 } }))
                              }}
                            />
                            <span className="form-check-sign" />
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col sm="1" className="mb-2 ">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={client.rcsTemp.rcsbot == 1 ? true : false}
                              value={client.rcsTemp.rcsbot}
                              onClick={(e) => {
                                e?.target?.checked === true
                                  ? setClient(prev => ({ ...prev, rcsTemp: { ...prev.rcsTemp, rcsbot: 1 } }))
                                  : setClient(prev => ({ ...prev, rcsTemp: { ...prev.rcsTemp, rcsbot: 0 } }))
                              }}
                            />
                            <span className="form-check-sign" />
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col sm="2" className="mb-2 ">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={client.rcsTemp.rcsactve == 1 ? true : false}
                              value={client.rcsTemp.rcsactve}
                              onClick={(e) => {
                                e?.target?.checked === true
                                  ? setClient(prev => ({ ...prev, rcsTemp: { ...prev.rcsTemp, rcsactve: 1 } }))
                                  : setClient(prev => ({ ...prev, rcsTemp: { ...prev.rcsTemp, rcsactve: 0 } }))
                              }}
                            />
                            <span className="form-check-sign" />
                          </Label>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col sm="4">
                    <Button type="submit" className="btn btn-icon btn-primary">
                      <i
                        className="tim-icons icon-double-right"
                        onClick={(e) => addClient(e)}
                      ></i>
                    </Button>
                  </Col>
                </Row>
              </Row>
            </CardBody>
          </Card>
        </Row>
      </div>
    </>
  );
};

export default CreateClient;
